// The current fixture (match), e.g. "Arsenal v Everton" — the central piece of
// app state everything is scoped to. Moving it into the store sets up M2, where
// widgets read the fixture from the store to fetch their per-fixture data.

export const DEFAULT_FIXTURE = "Arsenal v Everton";

// Seed from the legacy global fixture <select> so the store starts in sync with
// the already-rendered page (the select's selected option is the initial match).
export function readInitialFixture(): string {
  const sel = document.getElementById(
    "global-fixture-select"
  ) as HTMLSelectElement | null;
  return sel?.value || DEFAULT_FIXTURE;
}
